import type { SimulationDependency } from '../../simulation.types'
import { getTasksDependingOn } from './getTasksDependingOn'

/**
 * Adds a task to the list, then everything reading it, then everything reading
 * those. A task already in the list is left alone, which is what stops a
 * workflow whose tasks reference each other in a circle from going round
 * forever.
 */
export const findTasksWhichDependOnStaleData = ({
  collected,
  taskReferenceName,
  dependencies
}: {
  collected: string[]
  taskReferenceName: string
  dependencies: SimulationDependency[]
}): string[] =>
  collected.includes(taskReferenceName)
    ? collected
    : getTasksDependingOn({ taskReferenceName, dependencies }).reduce(
        (acc, dependent) =>
          findTasksWhichDependOnStaleData({
            collected: acc,
            taskReferenceName: dependent,
            dependencies
          }),
        [...collected, taskReferenceName]
      )
